import React from 'react'
import ReactDOM from 'react-dom'

import AppLayout from "../../../core/gd-app/component/app-layout"
import AppMain from "../../../core/gd-app/component/app-main/app-main"
import {SharedViewLogoType} from "../../../core/modules/shared-views/types"

export default class SharedViewAppProto {

    public domContainer: string

    public publicKey!: string
    public apiData: any
    public sharedView: any
    public customView: any

    public logo!: SharedViewLogoType

    constructor() {
        this.domContainer = 'ui-content-center';
    }

    init(appParams: any) {

        this.publicKey      = appParams.publicKey;
        this.apiData        = _.get(appParams, 'apiResponse.data', null);
        this.sharedView     = _.get(appParams, 'apiResponse.sharedView', null);
        this.customView     = _.get(appParams, 'apiResponse.customView', null);

        // Experimental
        this.logo           = gd?.modules?.sharedViews.logo // we need ? as in shared view gd.modules not initialized by def

        return this;
    }

    __destroy() {
        gd.bus.unsubscribe(this);
    }

    showBusy(callback: func) {
        gd.layout.loading.showAppBusy(callback);
    }

    hideBusy() {
        gd.layout.loading.hide();
    }

    renderNotFound() {
        const errorNumber = "404";
        const message = "The requested page is not found";

        ReactDOM.render(
            <AppLayout className="error-page">
                <AppMain className="main" type="full">
                    <div className="block">
                        <div className="error-number">{errorNumber}</div>
                        <div className="message">{message}</div>
                    </div>
                </AppMain>
            </AppLayout>,
            document.getElementById(this.domContainer)
        )
    }
}